module.exports = __webpack_public_path__ + "static/media/T7.62736b60.jpg";